import { useContext, useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import Swal from 'sweetalert2';
import authContext from '../../context/auth/authContext.js';
import { sendEmailValidation } from '../action/login2fa/sendEmailValidation';


export const ModalTwoFactor = () => {
  const dispatch = useDispatch();
  const AuthContext = useContext(authContext);
  const { token, tiene_2fa } = AuthContext;
  const uiState = useSelector((s) => s.uiState);
  const pdvInfoState = useSelector((s) => s.pdvInfoState);

  const pdvInfoEmail = pdvInfoState.pdvInfo.email;

  const initialFormValues = {
    email: '',
    confirmEmail: ''
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const { email, confirmEmail } = formValues;

  useEffect(() => {
    if (pdvInfoEmail && uiState.isTwoFactorOpen) {
      setFormValues(prevFormValues => ({
        ...prevFormValues,
        email: pdvInfoEmail,
      }));
    }
  }, [pdvInfoEmail, uiState.isTwoFactorOpen]);

  const handleInputChange = ({ target }) => {
    const { name, value } = target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  }

  const isFormValid = () => {
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || email.trim().length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Correo no valido',
        text: 'Ingresa un correo'
      });
      isValid = false;
    } else if (!emailRegex.test(email)) {
      Swal.fire({
        icon: 'warning',
        title: 'Correo no valido',
        text: 'Ingresa un correo valido. Asegúrate de que el formato del correo electrónico sea correcto'
      });
      isValid = false;
    } else if (!emailRegex.test(confirmEmail)) {
      Swal.fire({
        icon: 'warning',
        title: 'Correo no valido',
        text: 'Ingresa un correo válido en el campo de confirmación. Asegúrate de que el formato del correo electrónico sea correcto'
      });
      isValid = false;
    } else if (email.trim() !== confirmEmail.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Los correos no coinciden',
        text: 'Asegúrate de que los correos ingresados coincidan. Verifica que hayas escrito correctamente tu correo y que la confirmación coincida.'
      });
      isValid = false;
    }
    return isValid
  }

  const onSubmit = (e) => {
    e.preventDefault();
    if (isFormValid()) {
      dispatch(UIActions.uiLoadActive());
      sendEmailValidation(email, token, dispatch);
      handleHide();
    }
  }

  function handleHide() {
    dispatch(UIActions.closeTwoFactorAuthentication());
    setFormValues(initialFormValues);
  }

  return (
    <Modal
      onHide={handleHide}
      show={uiState.isTwoFactorOpen}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton
        className='gradientBlue colorWhite'>
        <Modal.Title id="contained-modal-title-vcenter">
          Verificación 2 pasos
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {tiene_2fa &&
          <div className="alert bg-warning" role="alert">
            <strong>¡Atención!</strong> Tu autenticación de dos factores (2FA) ya está activada. No es necesario configurarla nuevamente, a menos que desees cambiar el correo configurado.
          </div>
        }
        <p><strong>Sigue estos pasos para activar la verificación de dos pasos:</strong></p>
        <ol type="1">
          <li><strong>Ingresa tu correo:</strong> Proporciona tu dirección de correo electrónico para comenzar el proceso de verificación.</li>
          <li>
            <strong>Revisa tu bandeja de entrada:</strong> Busca el correo electrónico y sigue las instrucciones para validar tu correo.
            Si no encuentras el correo, asegúrate de revisar tu bandeja de spam o correo no deseado.
          </li>
          <li><strong>Ingresa de nuevo con tu contraseña y código de seguridad:</strong> Después de validar tu correo, accede nuevamente ingresando tu contraseña y el código de seguridad enviado a tu correo electrónico.</li>
        </ol>
        <Form onSubmit={onSubmit}>
          <Form.Group>
            {
              (pdvInfoEmail) &&
              <div className="bg-info text-white p-3">
                <small className="mb-0">Actualmente, cuentas con el siguiente correo electrónico asociado a este punto de venta: <strong>{pdvInfoEmail}</strong>. </small>
                <small className="mb-0">Si lo deseas, tienes la opción de configurar la autenticación de dos factores (2FA) con dicho correo o de utilizar un correo electrónico diferente.</small>
              </div>
            }
            <Form.Label>Ingresa tu correo</Form.Label>
            <Form.Control
              onChange={handleInputChange}
              id="email"
              name="email"
              value={email}
              type="mail"
              placeholder="Ingresa tu correo electrónico (Ej. ejemplo@mail.com)" />
            <Form.Control.Feedback type="invalid">Campo obligatorio</Form.Control.Feedback>
          </Form.Group>
          <Form.Group>
            <Form.Label>Confirma tu correo</Form.Label>
            <Form.Control
              onChange={handleInputChange}
              autoComplete='off'
              id="confirmEmail"
              name="confirmEmail"
              value={confirmEmail}
              type="mail"
              placeholder="Vuelve a ingresar tu correo electrónico" />
            <Form.Control.Feedback type="invalid">Campo obligatorio</Form.Control.Feedback>
          </Form.Group>
          <Button className="float-right mt-2" variant="primary" type="submit">
            Validar
          </Button>
          <Button onClick={handleHide} className="float-right mt-2 mr-2" variant="secondary">
            Cancelar
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  )
}
